import { render, staticRenderFns } from "./OrdinalParent.vue?vue&type=template&id=1a1bed68&scoped=true"
import script from "./OrdinalParent.vue?vue&type=script&lang=js"
export * from "./OrdinalParent.vue?vue&type=script&lang=js"
import style0 from "./OrdinalParent.vue?vue&type=style&index=0&id=1a1bed68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1bed68",
  null
  
)

export default component.exports